import {
	AccountBalance,
	ChecklistRtl,
	DonutSmall,
	Sharedata,
} from '@monthio/icons'
import { captureMessage } from '@sentry/react'

export const getIcon = (iconName: string) => {
	switch (iconName) {
		case 'banks':
			return <AccountBalance />
		case 'transactions':
			return <ChecklistRtl />
		case 'calculations':
			return <DonutSmall />
		case 'sharing':
			return <Sharedata />
		default:
			captureMessage(`Unknown icon name: ${iconName}`, {
				level: 'warning',
				tags: { iconName },
			})
			return null
	}
}
